import logo_grey80p from '@pn/ui/images/stackdx_intel_logo_grey80p.svg';
import logo_white from '@pn/ui/images/stackdx_intel_logo_white.svg';
import { Link } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  link: {
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
}));

export const AppTitle = () => {
  const { classes, theme } = useStyles();
  return (
    <Link to="/" className={classes.link}>
      <img
        src={theme.palette.mode === 'light' ? logo_grey80p : logo_white}
        alt="StackDX Intel"
        height={30}
      />
    </Link>
  );
};
